export function setLocale(locale) {
    return { locale, type: 'SELECT_LOCALE' };
}
